import { AppApi } from '../../apis/app.api';
import { LeadApi } from '../../apis/lead.api';
import { withRxJs } from '../../components/hoc/with-rx';
import SpinnerComponent from './spinner.component';

const SpinnerContainer = withRxJs(SpinnerComponent)(() => {
	return {
		defaultProps: { show: false },
		props: { show: LeadApi.showSpinner$, },
	};
});

export default SpinnerContainer;